// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1dXs0","select":"Header_select__2JIiW","clinic":"Header_clinic__3Fngi"};